/**
 * contain some general infos that can be used in other files
 */
// eslint-disable-next-line
export default {
    title: "Rêverie d'Antan",
    short_title: "Le bien-être par les plantes.",
    subtitle: "Le bien-être par les plantes.",
    description: process.env.REACT_APP_WEBSITE_DESC,
    url: "https://reveriedantan.be",
    location: {
      entreprise: {
        name: "Rêverie d'Antan",
        url: "https://reveriedantan.be"
      },
      email: "contact@reveriedantan.be",
    },
  };
  